import React, { useState } from "react";
import {
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  Divider,
  Typography,
  Box,
  CardMedia,
  Tooltip,
  TextField,
  CircularProgress,
  Backdrop,
} from "@mui/material";
import FlagIcon from "@mui/icons-material/Flag";
import InappropriateContent from "containers/InappropriateContent";
import { CloseOutlined } from "@mui/icons-material";
import report from "../../assets/icons/report.png";
import instance from "configs/axiosConfig";
import { APIRouteConstants } from "constants/routeConstants";
import { enqueueSnackbar } from "notistack";
import _ from "lodash";
import Loader from "components/Loader";
import { useLoader } from "Context/LoaderContext";
const FlagContent = ({ productName, productUrl, product }) => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const { showLoader, hideLoader } = useLoader();
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    reason: '',
  });
  const [errors, setErrors] = useState({
    email: '',
    reason: '',
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };


  const validateForm = () => {
    let valid = true;
    let newErrors = {
      email: '',
      reason: '',
    };

    // Email validation
    if (!formData.email) {
      newErrors.email = 'Email is required';
      valid = false;
    } else if (!emailPattern.test(formData.email)) {
      newErrors.email = 'Invalid email format';
      valid = false;
    }

    // Reason validation
    if (!formData.reason) {
      newErrors.reason = 'Reason is required';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };


  const handleClickOpen = (e) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setOpen(false);
  };
  
  const handleFlag = async (e) => {
    if(!validateForm()){
      return
    }
    showLoader("Loading data, please wait...")
    // e.stopPropagation();
    const date = new Date();

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
    const day = String(date.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    if (validateForm()) {
      const payload = {
        user_email: formData.email,
        reason_for_flagging: formData.reason,
        // product_url:
        //   "https://thevetstore.webbieshop.com/" + "product/" + product?.id,
        product_url: window.location.origin + "/product" + "/" + product?.id,
        // date: "",
        date: formattedDate,
      };

      try {
        const Response = await instance.post(
          APIRouteConstants.DASHBOARD.REPORT_PRODUCT,
          { ...payload }
        );
        const { data, response } = Response;
        if (response && response.status === 400 && response.data) {
          if (response.data.error) {
            enqueueSnackbar(response.data.error, { variant: "error" });
            hideLoader()
          } else if(
            response.data.message
          ){
            enqueueSnackbar(response.data.message, {
              variant: "error",
            });
            hideLoader()
          }else{

            for (let i in response.data) {
              enqueueSnackbar(_.capitalize(i) + ": " + response.data[i][0], {
                variant: "error",
              });
              setFormData({
                email: '',
                reason: '',
              })
              hideLoader()
            }
          }
        }
        if (data && data.success == true) {
          enqueueSnackbar(data?.message, { variant: "success" });
          hideLoader()
        }
      } catch (error) {
        hideLoader()
        console.error("Error submitting the form:", error);
      }
      handleClose(e);
    }
  };






  const handleTermsOpen = (e) => {
    e.stopPropagation();
    setTermsOpen(true);
  };

  const handleTermsClose = (e) => {
    e.stopPropagation();
    setTermsOpen(false);
  };


  

  return (
    <>
      <IconButton onClick={handleClickOpen} aria-label="flag">
        <Tooltip title="Report inappropriate content">
          <img src={report} style={{ width: "20px", color: "#ccc" }} />
        </Tooltip>
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
         PaperProps={{
    sx: {
      borderRadius: 1,
      p: 0,
    },
  }}
      >
        <Grid
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
            <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      px: 2,
      py: 1.5,
      borderBottom: "1px solid #eee",
    }}
  >
          <DialogTitle
            fontWeight={"500"}
            p={"8px !important"}
            fontSize={"1rem"}
          >
            Report Inappropriate Content
          </DialogTitle>
          </Box>
          <IconButton onClick={handleClose}>
            <CloseOutlined />
          </IconButton>
        </Grid>
        <Divider></Divider>
        <DialogContent onClick={(e) => e.stopPropagation()}  sx={{ px: 3 }}>
          <Box display={"flex"}>
            <Box
              component="img"
              src={product.product_image}
              alt={product.name}
              sx={{
                width: "100%",
                maxWidth: 150,
                margin: "auto",
                height: "auto",
                marginBottom: 2,
              }}
            />
          </Box>
          <Typography fontSize={"0.9rem"} fontWeight={"500"}>
            {product.name}
          </Typography>
          <Box>
            <Box pt={2}>
              {/* <Typography>Email</Typography> */}
              <TextField
                variant="outlined"
                label="Email"
                fullWidth
                name="email"
                value={formData.email}
                onChange={handleChange}
                size="small"
                onClick={(e) => e.stopPropagation()}
                error={!!errors.email} // Mark input as errored
                helperText={errors.email} // Show error message
                   sx={{
    "& .MuiInputLabel-root": {
      fontSize: "0.8rem",
    },
    "& .MuiInputLabel-shrink": {
      fontSize: "1rem",
    },
  }}
              />
            </Box>
            <Box pt={2}>
              <TextField
                fullWidth
                label="Reason to report
"
                name="reason"
                value={formData.reason}
                onChange={handleChange}
                // sx={{ pt: 1 }}
                multiline
                size="small"
                onClick={(e) => e.stopPropagation()}
                error={!!errors.reason} // Mark input as errored
                helperText={errors.reason} // Show error message
                    sx={{
    "& .MuiInputLabel-root": {
      fontSize: "0.8rem",
    },
    "& .MuiInputLabel-shrink": {
      fontSize: "1rem",
    },
  }}
              />
            </Box>
          </Box>

          <Box p={1} display={"flex"}>
             <Typography
      sx={{
        fontSize: {
          xs: "0.65rem",
          sm: "0.7rem",
          md: "0.75rem",
        },
        color: "#666",
      }}
    >
              Note:
              <br />
              If you find this content inappropriate, please click confirm and
              proceed to submit the report.
              <br />
              For more details or if you are unsure what this feature is about,
              please read the{" "}
              <Typography
                component="span"
                fontSize={"0.75rem"}
                color="primary"
                onClick={handleTermsOpen}
                style={{ textDecoration: "underline", cursor: "pointer" }}
              >
                terms and conditions
              </Typography>{" "}
              before flagging this content.
            </Typography>
          </Box>
        </DialogContent>
     <DialogActions
  sx={{
    px: 3,
    pb: 2,
    gap: 1,
    mb: 3,
  }}
>
  {/* Cancel Button - Red Outlined */}
  <Button
    variant="outlined"
    fullWidth
    color="error"
    onClick={handleClose}
    sx={{
      borderRadius: "4px",
      fontSize: {
        xs: "0.75rem",
        sm: "0.85rem",
        md: "0.9rem",
      },
      borderWidth: "1.5px",
      "&:hover": {
        borderWidth: "1.5px",
      },
    }}
  >
    Cancel
  </Button>

  {/* Confirm Button */}
  <Button
    variant="contained"
    fullWidth
    onClick={handleFlag}
    sx={{
      borderRadius: "4px",
      fontSize: {
        xs: "0.75rem",
        sm: "0.85rem",
        md: "0.9rem",
      },
    }}
  >
    Confirm
  </Button>

</DialogActions>
      </Dialog>
      <InappropriateContent termsOpen={termsOpen} handleTermsClose={handleTermsClose} />
    </>
  );
};

export default FlagContent;

